export default __webpack_public_path__ + "static/saas-banner-87a15da6f96e87758c08875d71a07f00.jpg";